<script>
import {useRoute} from "vue-router";
import {ref} from "vue";
import {useStore} from "vuex";
import Swal from "sweetalert2";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import $ from "jquery";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";

export default {
  name: "ConsultantsPage",
  components: {NavbarPage, LoadingPage},

  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let loading = ref(false)
    let store = useStore()

    let cat_id = useRoute().params.cat_id
    let sub_cat_id = useRoute().params.sub_cat_id

    let consultants = ref([])
    let consultantss = ref([])

    let page = ref('consultants')
    let name_page = ref(useRoute().params.cat_name)
    let page_select_place = ref('state')

    let country = ref([])
    let citys = ref([])
    // let streets = ref([])

    let place = ref({
      state_name: null,
      city_name: null,
      // street_name: null,
    })

    let data_filter = {
      state_id: null,
      city_id: null,
      // street_id: null,
    }

    if (store.state.filter.consultants){
      data_filter = store.state.filter.consultants
      place.value.state_name = data_filter.state
      place.value.city_name = data_filter.city
      set_filter(true)
    }else {
      load_consult()
    }

    let check_filter = ref(false)
    let input_search = ref()

    function get_country() {
      loading.value = true

      FreeWorld.Heisenberg({}, 'user/city').then((res) => {

        loading.value = false
        country.value = res.data.results

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, get_country)
      })
    }
    get_country()

    function load_consult() {

      page.value = 'consultants'
      place.value = {
        name: '',
        id: null,
        type: null,
      }

      let data = {}

      if (sub_cat_id == 0) {
        data.category = cat_id
      } else {
        data.sub_category = sub_cat_id
      }

      loading.value = true
      FreeWorld.Heisenberg(data, 'show_executives', true).then((result) => {

        loading.value = false
        let res = result.data
        consultants.value = res
        consultantss.value = res
        check_filter.value = false

      }).catch((res) => {
        loading.value = false
      Swals.Catch(res , load_consult)
      })

    }

    function search_style() {
      var input_search = document.getElementById('input_search')

      if (input_search.style.width == '120px') {
        input_search.style.width = '0px'
        input_search.style.fontSize = '0px'

      } else {
        input_search.style.width = '120px'
        input_search.style.fontSize = '20px'
      }
    }

    function open_select_place() {

      let alert = document.getElementById('select_state')
      let background = document.getElementById('alert_background_place')


      if (alert.style.display != 'block') {

        $("#select_state").removeClass('animate__fadeOut')
        $("#select_state").addClass('animate__fadeIn')
        alert.style.display = 'block'
        background.style.display = 'block'

      } else {

        if (place.value.city_name == null) {
          // place.value.street_name = null
          place.value.state_name = null
          place.value.city_name = null
          data_filter.state_id = null
          data_filter.city_id = null
          // data_filter.value.street_id = null
        }

        $("#select_state").addClass('animate__fadeOut')
        setTimeout(() => {
          alert.style.display = 'none'
          background.style.display = 'none'
          page_select_place.value = 'state'
        }, 600)

      }
    }

    function change_country(status, id, name) {

      if (status == 'state') {

        if (id !== -1) {
          country.value.forEach((item) => {
            if (id == item.id) {
              citys.value = item.city
            }
          })
          data_filter.state_id = id
          page_select_place.value = 'city'
        } else {
          data_filter.state_id = id
          place.value.city_name = 'همه ی استان ها'
          open_select_place()
        }

      } else if (status == 'city') {

        // citys.value.forEach((item) => {
        //   if (id == item.id) {
        //     streets.value = item.street
        //   }
        // })
        // page_select_place.value = 'street'

        data_filter.city_id = id
        place.value.city_name = name
        open_select_place()

      }
      // else if (status == 'all_street') {
      //   place.value.street_name = 'همه خیابان ها'
      //   data_filter.value.street_id = -1
      //   open_select_place()
      // } else if (status == 'street') {
      //   place.value.street_name = name
      //   data_filter.value.street_id = id
      //   open_select_place()
      // }

    }

    function search_prod() {
      consultants.value = []
      consultantss.value.forEach((item) => {
        if (item.name.includes(input_search.value)) {
          consultants.value.push(item)
        }
      })
    }

    async function set_filter(valid) {

      if (sub_cat_id == 0) {
        data_filter.category = cat_id
      } else {
        data_filter.sub_category = sub_cat_id
      }

      if (!valid && place.value.city_name == null) {

        Swal.fire({
          text: "لطفا مکان مورد نظر خود را انتخاب کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })
        return false
      }

      data_filter.city = place.value.city_name
      data_filter.state = place.value.state_name
      store.commit('set_filter_consultants', new Object(data_filter))

      loading.value = true

      await FreeWorld.Heisenberg(data_filter, 'show_executives', true).then((result) => {

        loading.value = false
        consultants.value = result.data
        check_filter.value = true
        page.value = 'consultants'

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, set_filter)
      })

    }


    return {

      search_style,
      loading,
      consultants,
      page,
      place,
      open_select_place,
      change_country,
      country,
      citys,
      // streets,
      page_select_place,
      set_filter,
      load_consult,
      check_filter,
      input_search,
      search_prod,
      name_page,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div @click="open_select_place" id="alert_background_place" class="alert_background"></div>
  <div dir="ltr" id="select_state" class="animate__animated px-5 mt-3 max_width">
    <div class="bg-white rounded-4 border-costom">
      <div class="bg-color-liner position-relative rounded-top-4 d-flex justify-content-center align-items-center">
        <img class="py-4" style="width: 100px" src="../assets/img/location_white.svg" alt="">
      </div>

      <div v-if="page_select_place === 'state' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">

        <div @click="change_country('state', -1)" class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">همه استان ها</p>
        </div>

        <div v-for="item in country" :key="item.id" @click="change_country('state', item.id)"
             class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">{{ item.name }}</p>
        </div>

      </div>

      <div v-if="page_select_place === 'city' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">

        <div @click="change_country('city', -1 , 'همه ی شهر ها')" class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">همه شهر ها</p>
        </div>

        <div v-for="item in citys" :key="item.id" @click="change_country('city', item.id , item.name)"
             class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">{{ item.name }}</p>
        </div>

      </div>

      <!--        <div v-if="page_select_place == 'street' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">-->

      <!--          <div @click="change_country('all_street')" class="d-flex justify-content-between py-3">-->
      <!--            <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">-->
      <!--            <p class="m-0 font-5">همه خیابان ها</p>-->
      <!--          </div>-->

      <!--          <div v-for="item in streets" :key="item.id" @click="change_country('street', item.id , item.name)"-->
      <!--               class="d-flex justify-content-between py-3">-->
      <!--            <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">-->
      <!--            <p class="m-0 font-5">{{ item.name }}</p>-->
      <!--          </div>-->

      <!--        </div>-->

    </div>
  </div>


  <div id="main" class="bg-main" :class="loading ? 'activeClass' : '' ">

    <div dir="ltr" v-if="page === 'consultants' " id="main" :class="loading ? 'activeClass' : '' " class="bg-main">

      <div class="div-top-arrow bg-color d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <div @click="page = 'filter' " class="position-relative">
            <div v-if="check_filter"
                 class="py-1 px-2 d-flex justify-content-center align-items-center bg-danger rounded-pill position-absolute">
              <p class="font-6 m-0">1</p>
            </div>
            <img class="" style="width: 3rem" src="../assets/img/setting_icon_no_shadow.svg" alt="">
          </div>
          <div class="d-flex align-items-center position-relative">
            <img @click="search_style" class="z-1 mx-2" style="width: 3rem" src="../assets/img/search_bg-white.svg"
                 alt="">
            <input v-model="input_search" @input="search_prod" id="input_search"
                   class="input_search bg-white font-5 text-center" type="text" placeholder="جستجو">
          </div>
        </div>

        <div class="d-flex align-items-center">
          <p class="m-0 font-5">{{ name_page }}</p>

          <div onclick="history.back()">
            <img class="svg-arrow" src="../assets/img/back.svg" alt="">
          </div>
        </div>
      </div>
      <br>
      <br>
      <br>

      <div v-if="consultants.length == 0 "
           class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
          <br>
          <p dir="rtl" class="font-5 ">
            در حال حاضر مشاوری وجود ندارد...
          </p>
        </div>
      </div>

      <div v-else class="p-body mt-2">

        <router-link v-for="item in consultants" :key="item.id" :to="{name:'DetailsExecutives' , params:{prof_id:item.id}}" class="animate__animated animate__fadeIn shadow-costom rounded-shaped d-flex align-items-center text-decoration-none justify-content-between bg-white mb-2 rounded-4 p-2">
          <div style="width: calc(100% - 10.5rem);" class="px-2 py-2 d-flex flex-column justify-content-around">
            <p class="font-5 mb-2 font-bold text-end">
              {{ item.name }}
            </p>
            <p class="text_information font-5">{{ item.description }}</p>
            <p class="m-0 font-5 text-end">
              <span>{{ item.state_name }}</span>
              -
              <span>{{ item.city_name }}</span>
            </p>
          </div>

          <div class="img_executives animated-background rounded-4">
            <img class="w-100 h-100 rounded-4" :src="item.profile_pic" alt="">
          </div>
        </router-link>

      </div>

    </div>

    <div v-if="page === 'filter' " id="main" :class="loading ? 'activeClass' : '' " class="bg-main" dir="ltr">

      <div class="div-top-arrow bg-color d-flex align-items-center justify-content-between">

        <div @click="load_consult" class="d-flex align-items-center">
          <p class="m-0">
            حذف
          </p>

          <img class="svg-arrow" src="../assets/img/closing.svg" alt="">
        </div>

        <div class="d-flex align-items-center">
          <p class="m-0">
            فیلتر مجریان
          </p>

          <img @click="page = 'consultants' " class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>


      </div>
      <br>
      <br>
      <br>


      <div class="bg-white rounded-4 mt-3 py-4 border-costom p-body mx-3 animate__animated animate__fadeIn">

        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

            <div @click="open_select_place" v-if="place.city_name != null " class="d-flex ml-2">

              <p class="m-0 font-5 d-flex align-items-center">{{ place.city_name }}</p>

            </div>

            <p v-else @click="open_select_place" class="m-0 font-5 mx-2">
              انتخاب
            </p>

          </div>


          <p class="font-5 m-0">
            محدوده فعالیت
          </p>
        </div>

      </div>

      <br>
      <br>
      <br>
      <br>
      <div class="button_div w-100 d-flex justify-content-center animate__animated animate__fadeIn">
        <button @click="set_filter" class="w-60 bg-color font-5 rounded-4 border-costom font-color-white my-2 ">
          اعمال فیلتر
        </button>
      </div>

    </div>

  </div>

  <div id="web" class="bg-main" :class="loading ? 'activeClass' : '' ">

    <div>
      <NavbarPage></NavbarPage>
      <br><br>

      <div class="d-flex justify-space-between position-relative">
        <div class="">
          <div v-if="consultants.length == 0"
               class="list_products_web w-75 p-body d-flex flex-column justify-content-center align-items-center"
               style="height: 60vh">
            <div class="d-flex flex-column align-items-center">
              <img style="width: 100px" src="../assets/img/shop_none.svg" alt="">
              <br>
              <p class="font-5">
                در حال حاضر مجری وجود ندارد...
              </p>
            </div>
          </div>

          <div v-else style="width: calc(100% - 30%)" class="list_products_web">
            <!--*** محصولات ***-->
            <router-link v-for="item in consultants" :key="item.id" :to="{name:'DetailsExecutives' , params:{prof_id:item.id}}"
                         class="animate__animated animate__fadeIn mx-1 shadow-costom rounded-shaped products_custom_web d-flex align-items-center text-decoration-none justify-content-between bg-white mb-2 rounded-4 p-2">
              <div class="animated-background rounded-4 div_img_products_web">
                <img class="w-100 h-100 rounded-4" :src="item.profile_pic" alt="">
              </div>

              <div style="width: calc(100% - 10.5rem);" class="px-2 py-2">
                <p class="font-5 mb-2 font-bold">
                  {{ item.name }}
                </p>
                <p class="text_information font-5">{{ item.description }}</p>
                <p class="m-0 font-5">
                  <span>{{ item.state_name }}</span>
                  -
                  <span>{{ item.city_name }}</span>
                </p>
              </div>
            </router-link>
          </div>
        </div>


        <div class="sidebar">
          <div class="d-flex justify-content-center">
            <input v-model="input_search" @input="search_prod" class="input_search text-center bg-white font-5 rounded-pill"
                   type="text"
                   placeholder="به دنبال چه محصولی هستی؟">
          </div>

          <div class="d-flex align-items-center justify-space-between px-4 py-2">
            <p @click="load_consult" class="m-0 font-5 delete_filter">
              حذف فیلتر
            </p>

            <p class="font-bold m-0 font-5">
              : فیلتر ها
            </p>
          </div>
          <div class="bg-white rounded-4 mt-3 py-4 border-costom p-body mx-3 animate__animated animate__fadeIn">

            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">

                <div @click="open_select_place" v-if="place.city_name != null " class="d-flex ml-2">

                  <!--                  <p class="m-0 font-5 d-flex align-items-center ">{{ place.street_name }}</p>-->

                  <!--                  <span class="mx-1">-</span>-->

                  <p class="m-0 font-5 d-flex align-items-center">{{ place.city_name }}</p>

                </div>

                <p v-else @click="open_select_place" class="m-0 font-5 mx-2">
                  انتخاب
                </p>

              </div>


              <p class="font-5 m-0">
                محدوده فعالیت
              </p>
            </div>

            <br>
            <br>

            <div class="d-flex justify-content-center">
              <v-btn @click="set_filter" class="w-60 bg-color font-5 rounded-3 border-costom text-white my-2">
                اعمال فیلتر
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<style scoped>

.input_search {
  height: 3rem;
  position: absolute;
  left: 50%;
  width: 0;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  border: none;
  transition: 0.5s;
}

.img_executives {
  width: 10rem;
  height: 10rem;
}

.text_information {
  height: 5rem;
  width: 100%;
  white-space: initial;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
}

#select_state {
  display: none;
  position: fixed;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.button_div {
  height: 80px;
  position: fixed;
  bottom: 0;
  max-width: 700px;
}

.alert_background {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(79, 78, 78, 0.44);
  display: none;
  z-index: 2;
}


.sidebar {
  position: fixed;
  right: 0;
  width: 30%;
  direction: ltr;
  height: 100%;
  overflow-y: scroll;
}

.list_products_web {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 2%;
  flex-wrap: wrap;
}

.products_custom_web {
  padding: 1rem;
  background-color: white;
  flex-basis: 49%;
  flex-grow: 0;
}

@media (max-width:1285px ) {
  .products_custom_web{
    min-width: 27rem;
    flex-grow: 1;
  }
}

.div_img_products_web {
  width: 10rem;
  height: 10rem;
}

.delete_filter {
  transition: .5s;
  padding: .5rem;
  border-radius: 20px;
}

.delete_filter:hover {
  background-color: #818285;
  color: white;
  outline: 1px solid #e15900;
}
</style>